import React, { useMemo } from 'react';
import GoBoard from './GoBoard';
import { computeBoardState } from '../services/boardUtils';
import { sgfToPoint } from '../services/coordinateUtils';
import type { Move, BoardMark } from '../types/game';

interface Props {
  moves: Move[];
  boardSize: number;
  moveNumber: number;
  size: number;
  handicap?: number;
}

const BoardThumbnail: React.FC<Props> = ({ moves, boardSize, moveNumber, size, handicap = 0 }) => {
  const stones = useMemo(
    () => computeBoardState(moves, boardSize, moveNumber, handicap),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [moveNumber, boardSize, moves.length]
  );

  const marks = useMemo((): BoardMark[] => {
    if (moveNumber < 1 || moveNumber > moves.length) return [];
    const lastMove = moves[moveNumber - 1];
    if (!lastMove || lastMove.mv === 'pass' || lastMove.mv === 'resign') return [];
    const pt = sgfToPoint(lastMove.mv, boardSize);
    if (!pt) return [];
    return [{ coord: pt, type: 'circle' as const }];
  }, [moves, moveNumber, boardSize]);

  return (
    <GoBoard
      size={boardSize}
      stones={stones}
      marks={marks}
      showHover={false}
      width={size}
      height={size}
    />
  );
};

export default BoardThumbnail;
